"use strict";
// tslint:disable:ext-variable-name no-empty-interface
Object.defineProperty(exports, "__esModule", { value: true });
